import { render, staticRenderFns } from "./TeacherEditDay.vue?vue&type=template&id=71fcebfc&"
import script from "./TeacherEditDay.vue?vue&type=script&lang=js&"
export * from "./TeacherEditDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports